import { css } from 'lit';

var css_248z = css`:host{--tooltip-max-width:20rem;display:inline-block}.tooltip-inner{max-width:var(--tooltip-max-width)}div{max-width:fit-content}`;

export { css_248z as default };
//# sourceMappingURL=sgds-tooltip2.js.map
